export default "__VITE_ASSET__DnoHtwDs__"